import {SettingSubGroup} from "./setting-sub-group";

export class SettingGroup {
  name: string;
  groups: SettingSubGroup[];
}
